import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import React from "react";
import styled from "styled-components";

const StyledNextButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 2vw;
`;
const NextButton = ({
  className = "",
  styles = {},
  variant = "outlined",
  text = "next",
  onClick = () => {},
  iconComponent = null,
  disabled = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleOnClick = () => {
    onClick();
  };
  return (
    <StyledNextButtonContainer className={className + " next-button"}>
      <Button
        className="col-auto"
        disabled={disabled}
        sx={{
          backgroundColor: "transparent",
          color: theme.COLORS.WHITE.backgroundWhite,
          borderRadius: "120px 0 120px 120px",
          borderColor: "white",
          fontWeight: "bold",
          fontSize: "0.7rem",
          ":hover": {
            backgroundColor: theme.COLORS.BLUE.lightBlue2,
          },
          ...styles,
        }}
        variant={variant}
        onClick={handleOnClick}
      >
        {t(text)}
        {iconComponent()}
      </Button>
    </StyledNextButtonContainer>
  );
};

export default NextButton;
